import { Breadcrumb } from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams } from 'peach/router'

import { useInternalBorrowerGet } from 'core/types'

const PersonBreadcrumb = ({ personId, ...rest }) => {
  const { companyId } = useParams<{
    companyId?: string
  }>()

  const { data: person, isLoading } = useInternalBorrowerGet({
    companyId,
    personId,
  })

  const name = isLoading ? 'Loading…' : getName(person)

  return <Breadcrumb title={name} {...rest} />
}

export default PersonBreadcrumb
